import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { Base64UrlService } from '../../../services/base64url.service';

@Component({
    selector: 'tt-edi-export',
    templateUrl: './edi-export.component.html',
    styleUrls: ['./edi-export.component.css'],
    standalone: false
})
export class EdiExportComponent implements OnInit {
    ediExportKeyno;

    public selectedBgEdiExportMain: string = 'DETAILS';

    public edit?: Edit;

    public selectListEdiDestinations: Item[] = [];

    public selectListExportProcedures: Item[] = [];

    constructor(private stateService: StateService, private base64: Base64UrlService, private datatask: DataTaskService) {
        this.ediExportKeyno = this.stateService.getStateParams()['edi_export_keyno'];
    }

    private async loadEdit() {
        if (!!this.ediExportKeyno) {
            this.edit = (await this.datatask.Post(1172, { edi_export_keyno: this.ediExportKeyno }))[0];

            if (!!this.edit) {
                this.edit.filecontent = this.base64.Decode(this.edit.filecontent);
            }
        }
    }

    private async loadEdiDestinations() {
        this.selectListEdiDestinations = await this.datatask.Post(987);
    }

    private async loadExportProcedures() {
        this.selectListExportProcedures = await this.datatask.Post(891);
    }

    private async init() {
        this.loadEdit();
        this.loadEdiDestinations();
        this.loadExportProcedures();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    edi_export_keyno: string;
    reg_datetime: string;
    edi_destination_keyno: string;
    filename: string;
    filecontent: string;
    process_status: string;
    edi_process_status_name: string;
    processing_create_start_datetime: string;
    processing_create_end_datetime: string;
    p2_exportproc_keyno: string;
    processing_message: string;
    reg_by_portal_user_name: string;
    processing_create_count: string;
    add_type: string;
    processing_create_millisec: string;
    delivery_start_datetime: string;
    delivery_end_datetime: string;
    delivery_try_count: string;
}
